import * as React from 'react';

import { Tooltip } from '@mantine/core';
import type { TooltipProps } from '@mantine/core';

// Omit classNames so callers can't override the shared styling.
type InfoTooltipProps = Omit<TooltipProps, 'classNames'>;

export function InfoTooltip({ children, ...props }: InfoTooltipProps) {
  return (
    <Tooltip withArrow arrowSize={10} withinPortal openDelay={150} classNames={{ tooltip: 'help-tooltip', arrow: 'help-tooltip-arrow' }} {...props}>
      {children}
    </Tooltip>
  );
}
